import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inicio-administrador',
  templateUrl: './inicio-administrador.component.html',
  styleUrls: ['./inicio-administrador.component.css']
})
export class InicioAdministradorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
